import { gql } from "@apollo/client";

export default gql`
  query getCallAdminLogDetail($callSid: String!){
    getCallAdminLogDetail(callSid: $callSid){
        success
        data{
            _id
            callSid
            parentCallSid
            childCallSids
            customer
            customerName
            platformId
            callType
            callerCPersonId
            calleeCPersonId
            callerName
            calleeName
            status
            direction
            logs{
                stepName
                type
                status
                correlationId
                data
                duration
                timestamp
                message
                error
            }
            createdAt
            updatedAt
            callerNumber
            totalDuration
            totalCost
        }
        code
        message
    }
}
`
